// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1123":"7146c2cb","1499":"cc00fa56","1809":"7146c2cb","2225":"69121393","3775":"7146c2cb","3895":"69121393","6217":"69121393"}[chunkId] + ".chunk.css";
};